import {
  Box,
  Checkbox,
  Typography,
  Button,
  useTheme,
  Divider,
} from "@mui/material";
import roomImg2 from "../../../assets/images/rooms/room2.jpg";
import PlaceIcon from "@mui/icons-material/Place";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BedroomChildIcon from "@mui/icons-material/BedroomChild";
import dayjs from "dayjs";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useTranslation } from "react-i18next";
import { useRoomFinder } from "../../../contexts/RoomFinderContext";

export default function Rooms({
  idx,
  data,
  formValues,
  selectedRooms,
  setSelectedRooms,
  bookingData,
  setBookingData,
}) {
  const { t } = useTranslation();
  const { seeAvailableRoomNumber } = useRoomFinder();

  const theme = useTheme();
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 999);

  useEffect(() => {
    const checkInDate = dayjs(formValues?.checkIn);
    const checkOutDate = dayjs(formValues?.checkOut);

    if (!checkInDate.isValid() || !checkOutDate.isValid()) {
      setBookingData({});
      return;
    }

    const formattedCheckIn = checkInDate.format("YYYY-MM-DD");
    const formattedCheckOut = checkOutDate.format("YYYY-MM-DD");
    // Eğer sadece bir oda seçiliyse, instantBookingData'yı güncelle
    if (selectedRooms.length === 1) {
      // formValues'dan checkIn ve checkOut değerlerini alıyoruz

      const selectedRoomData = selectedRooms[0]; // Tek seçili oda

      // selectedRoomData'nın bir kopyasını oluşturuyoruz ve checkIn/checkOut bilgilerini ekliyoruz
      const instantBookingData = {
        ...selectedRoomData,
        checkIn: formattedCheckIn,
        checkOut: formattedCheckOut,
      };

      // startRequest için de benzer bir yapı kullanabilirsiniz, gerekiyorsa
      const startRequestData = {
        ...selectedRoomData,
        checkIn: formattedCheckIn,
        checkOut: formattedCheckOut,
        currency: formValues?.currency,
        numberOfStudents: formValues?.numberOfStudents,
        occupancy: formValues?.occupancy,
        additionalNote: formValues?.additionalNote,
        predicted_checkin: formattedCheckIn,
        predicted_checkout: formattedCheckOut,
        // Buraya startRequest'a özgü diğer alanlar eklenebilir
      };

      const startQuoteData = {
        options: [
          {
            name: `Option 1`,
            courses: [
              {
                course_id: selectedRoomData?.course_id,
                campus_id: selectedRoomData?.campus_id,
                option_course_name: selectedRoomData?.course_name,
                option_course_partner: selectedRoomData?.partner_name,
                option_course_campus: selectedRoomData?.campus_name,
                option_course_start_date: formattedCheckIn,
                option_course_end_date: formattedCheckOut,
                option_course_course_type: selectedRoomData?.type_name,
              },
            ],
          },
        ],
        // ...selectedRoomData,
      };
      setBookingData({
        // Burada instantBookingData'nızı nasıl oluşturmak istiyorsanız o şekilde doldurun
        instantBooking: instantBookingData,
        startRequest: startRequestData,
        startQuote: startQuoteData,
        // Diğer gerekli veriler...
      });
    } else {
      // Seçili odaların sayısı 1'den farklı ise, instantBookingData'yı temizle veya başka bir güncelleme yap
      if (selectedRooms.length > 1) {
        const startRequestData = {
          rooms: selectedRooms, // Seçili odaları bir dizi olarak tutuyoruz
          formDetails: {
            // Form verilerini ayrı bir nesne içinde tutuyoruz
            currency: formValues?.currency,
            numberOfStudents: formValues?.numberOfStudents,
            occupancy: formValues?.occupancy,
            additionalNote: formValues?.additionalNote,
            predicted_checkin: formattedCheckIn,
            predicted_checkout: formattedCheckOut,
          },
        };

        let options = [];

        selectedRooms?.forEach((room, idx) => {
          options.push({
            name: `Option ${idx + 1}`,
            courses: [
              {
                course_id: room?.course_id,
                campus_id: room?.campus_id,
                option_course_name: room?.course_name,
                option_course_partner: room?.partner_name,
                option_course_campus: room?.campus_name,
                option_course_start_date: formattedCheckIn,
                option_course_end_date: formattedCheckOut,
                option_course_course_type: room?.type_name,
              },
            ],
          });
        });

        const startQuoteData = {
          options,
        };

        setBookingData({
          startRequest: startRequestData,
          startQuote: startQuoteData,
        });
      } else {
        setBookingData({});
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRooms, formValues]); // selectedRooms değiştiğinde bu useEffect tetiklenecek

  // const handleChange = (e, roomData) => {
  //   if (e.target.checked) {
  //     setSelectedRooms((prevRooms) => [...prevRooms, roomData]);
  //   } else {
  //     setSelectedRooms((prevRooms) =>
  //       prevRooms.filter((room) => room !== roomData)
  //     );
  //   }
  // };
  const handleChange = (e, roomData) => {
    if (e.target.checked) {
      setSelectedRooms((prevRooms) => [...prevRooms, roomData]);
    } else {
      setSelectedRooms((prevRooms) =>
        prevRooms.filter((room) => room.room_id !== roomData.room_id)
      );
    }
  };

  // Resize event listener
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 999);
    };

    // Event listener'ı ekleyin
    window.addEventListener("resize", handleResize);

    // Cleanup function olarak event listener'ı kaldırın
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Bu useEffect'i sadece bileşen mount olduğunda çalıştırmak için boş bir bağımlılık dizisi verin.
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin

  const isRoomSelected = (room, selectedRooms) => {
    return selectedRooms.some((selectedRoom) => {
      const { room_id, ...roomProps } = room;
      const { room_id: selectedRoomId, ...selectedRoomProps } = selectedRoom;
      return JSON.stringify(roomProps) === JSON.stringify(selectedRoomProps);
    });
  };

  return (
    <Box
      sx={{
        marginTop: "4rem",
        boxShadow: lightMode && "3px 3px 5px #dedede",
        padding: "1.25rem",
        background: lightMode
          ? data?.course_promotion_name
            ? "#0080001c"
            : "#fff"
          : data?.course_promotion_name
            ? "#0080001c"
            : "#292929",
        display: "flex",
        position: "relative",
        // paddingBottom: { xs: "10rem", xl: "1.25rem" },
        flexDirection: { xs: "column", md: "row" },
        borderRadius: "1rem",
      }}
      key={idx}
    >
      <Box
        sx={{
          marginRight: { xs: "0", md: "1rem" },
          width: isMobile ? "100%" : "220px",
          height: "220px",
        }}
      >
        <img
          src={
            data?.course_image
              ? data?.course_image.replace("devcrm", "devcrm1")
              : roomImg2
          }
          alt={data?.course_name || data?.campus_name || ""}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Box>
      {/* room objesindeki özelliklere göre içeriği güncelleyin */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginTop: { xs: "1rem", md: "0" },
        }}
      >
        <Box
          sx={{
            // marginLeft: { xs: "0", md: "2rem" },
            marginTop: "auto",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h5"
              fontWeight={700}
              color={theme.palette.customRed.orange}
            >
              <span style={{ color: theme.palette.primary.main }}>
                {data?.partner_name}
              </span>{" "}
              <span
                style={{ color: lightMode ? "#444" : "#fff", fontWeight: 400 }}
              >
                /
              </span>{" "}
              {data?.campus_name}
            </Typography>

            {seeAvailableRoomNumber ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "1rem",
                }}
              >
                <BedroomChildIcon
                  sx={{ color: lightMode && "#23416a", fontSize: "48px" }}
                />

                <Typography
                  variant="h5"
                  sx={{ fontSize: "27px", lineHeight: "32px" }}
                  color={theme.palette.primary.main}
                >
                  {data?.count > 20 ? 20 : data?.count}
                </Typography>
              </Box>
            ) : null}
          </Box>
          <Typography
            variant="h6"
            fontWeight={400}
            color={theme.palette.customRed.orange}
          >
            {data.course_name}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            {/* <Typography
              variant="h6"
              sx={{ fontSize: "18px", lineHeight: "20px" }}
            >
              {data?.partner_name}
            </Typography> */}
            {/* <Typography
              sx={{
                marginLeft: { xs: "0", md: "1rem" },
                marginRight: "1rem",
                marginTop: { xs: ".5rem", md: "0" },
                marginBottom: { xs: ".5rem", md: "0" },
                fontSize: "18px",
                lineHeight: "20px",
              }}
              variant="h6"
            >
              {data?.campus_name}
            </Typography> */}

            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                fontSize: "18px",
                lineHeight: "20px",
              }}
              variant="h6"
            >
              <PlaceIcon
                sx={{
                  position: "relative",
                  top: "-3px",
                  color: `#23416a`,
                }}
              />
              {data?.campus_address}
            </Typography>
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "1rem",
              right: "1rem",
            }}
          >
            <Checkbox
              // checked={selectedRooms.includes(data)}
              checked={isRoomSelected(data, selectedRooms)}
              onChange={(e) => handleChange(e, data)}
              sx={{ padding: "0" }}
              {...label}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              alignItems: { xs: "flex-start", lg: "flex-end" },
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  marginTop: { xs: ".5rem", md: "0" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "18px",
                    lineHeight: "24px",
                    minWidth: { xs: "100px", md: "150px" },
                    textTransform: 'capitalize',
                    width: { xs: "100px", md: "150px" },
                  }}
                  variant="h6"
                  color={theme.palette.customRed.orange}
                >
                  {t("type")}
                </Typography>

                <Typography
                  sx={{
                    marginLeft: "1rem",
                    lineHeight: "24px",
                    fontSize: "18px",
                  }}
                  variant="h6"
                >
                  {data?.type_name}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginTop: { xs: ".5rem", md: "0" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "18px",
                    lineHeight: "24px",
                    minWidth: { xs: "100px", md: "150px" },
                    textTransform: 'capitalize',
                    width: { xs: "100px", md: "150px" },
                  }}
                  variant="h6"
                  color={theme.palette.customRed.orange}
                >
                  {t("checkIn")}
                </Typography>

                <Typography
                  sx={{
                    marginLeft: "1rem",
                    lineHeight: "24px",
                    fontSize: "18px",
                  }}
                  variant="h6"
                >
                  {formValues?.checkIn?.format("YYYY-MM-DD")}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginTop: { xs: ".5rem", md: "0" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "18px",
                    lineHeight: "24px",
                    minWidth: { xs: "100px", md: "150px" },
                    textTransform: 'capitalize',
                    width: { xs: "100px", md: "150px" },
                  }}
                  variant="h6"
                  color={theme.palette.customRed.orange}
                >
                  {t("duration")}
                </Typography>

                <Typography
                  sx={{
                    marginLeft: "1rem",
                    lineHeight: "24px",
                    fontSize: "18px",
                  }}
                  variant="h6"
                >
                  {data?.duration < 7
                    ? data?.duration > 1
                      ? data?.duration + ` days`
                      : data?.duration + ` day`
                    : data?.duration % 7 === 0
                      ? data?.duration / 7 === 1
                        ? data?.duration / 7 + ` ${t("week")}`
                        : data?.duration / 7 + ` ${t("weeks")}`
                      : Math.floor(data?.duration / 7) +
                      /*      ` week${Math.floor(data?.duration / 7) === 1 ? `` : `s`
                           } and ` */
                      ` ${t("week")} `
                      +
                      (data?.duration % 7) +
                      // ` day${data?.duration % 7 === 1 ? `` : `s`} `
                      ` ${t("day")}`
                  }
                  {/* {data ? (data.duration / 7).toFixed(2) : `-`} week/s */}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  marginTop: { xs: ".5rem", md: "0" },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: "18px",
                    lineHeight: "24px",
                    minWidth: { xs: "100px", md: "150px" },
                    textTransform: 'capitalize',
                    width: { xs: "100px", md: "150px" },
                  }}
                  variant="h6"
                  color={theme.palette.customRed.orange}
                >
                  {t("weekly")}
                </Typography>

                <Typography
                  sx={{
                    marginLeft: "1rem",
                    lineHeight: "24px",
                    fontSize: "18px",
                  }}
                  variant="h6"
                >
                  {data ? data?.price?.toFixed(2) : `-`} GBP/{t("week")}
                </Typography>

                {process.env.NODE_ENV === "development" &&
                data?.pricing_source === "daily" ? (
                  <Box
                    title={t("Dynamic pricing")}
                    sx={{
                      marginLeft: "1rem",
                      alignSelf: "center",
                      background: "#e9f5ea",
                      color: "#2e7d32",
                      padding: ".15rem .6rem",
                      borderRadius: "1rem",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    ✓ {t("Dynamic")}
                  </Box>
                ) : data?.pricing_source === "weekly" &&
                  data?.daily_nights_total > 0 ? (
                  <Box
                    title={`${t("Dynamic pricing not applied")} — ${data?.daily_nights_priced ?? 0} ${t("of")} ${data?.daily_nights_total ?? 0} ${t("nights have a daily price, so the weekly price was used")}`}
                    sx={{
                      marginLeft: "1rem",
                      alignSelf: "center",
                      background: "#fdf3e6",
                      color: "#b9770e",
                      padding: ".15rem .6rem",
                      borderRadius: "1rem",
                      fontSize: "12px",
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    ⚠ {t("Weekly")} — {data?.daily_nights_priced ?? 0}/{data?.daily_nights_total ?? 0} {t("nights priced")}
                  </Box>
                ) : null}
              </Box>
            </Box>

            {/* <Box
              sx={{
                display: "flex",
                marginTop: { xs: ".5rem", md: "0" },
              }}
            >
              <Typography
                sx={{
                  fontWeight: "700",
                  fontSize: "18px",
                  lineHeight: "24px",
                  minWidth: { xs: "100px", md: "150px" },
                  textTransform: 'capitalize',
                  width: { xs: "100px", md: "150px" },
                }}
                variant="h6"
                                  color={theme.palette.customRed.orange}

              >
                Dual Occupancy
              </Typography>

              <Typography
                sx={{
                  marginLeft: "1rem",
                  lineHeight: "24px",
                  fontSize: "18px",
                }}
                variant="h6"
              >
                50.00 GBP/Week
              </Typography>
            </Box> */}
          </Box>
        </Box>
        <Divider sx={{ my: 3 }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            marginLeft: "auto",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {data?.course_promotion_discount_amount && data?.course_promotion_discount_type !== "fee" ? (
              <Typography
                sx={{
                  marginLeft: "auto",
                  marginTop: "auto",
                  width: "max-content",
                  color: "green",
                  mt: "1rem",
                }}
                variant="h6"
              >
                {`${(
                  (data?.pricing_source === "daily" && data?.total_price != null
                    ? data.total_price
                    : (data?.duration / 7) * data?.price) -
                  data?.course_promotion_discount_amount
                ).toFixed(2)} GBP`}
                {/* {((data?.duration / 7) * data?.discounted_price).toFixed(2)} GBP */}
              </Typography>
            ) : null}

            <Typography
              sx={{
                marginLeft: "auto",
                marginTop: "1rem",
                width: "max-content",
                textDecoration: data?.course_promotion_discount_amount && data?.course_promotion_discount_type !== "fee"
                  ? "line-through"
                  : "none",
              }}
              variant="h6"
            >
              {`${(data?.pricing_source === "daily" && data?.total_price != null
                ? data.total_price
                : (data?.duration / 7) * data?.price).toFixed(2)} GBP`}

              {/* {((data?.duration / 7) * data?.price).toFixed(2)} GBP */}
            </Typography>
            {data?.course_promotion_name ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "auto",
                  width: { xs: "fit-content", xl: "max-content" },
                  background: "#008b0087",
                  padding: ".25rem .75rem",
                  borderRadius: "2rem",
                }}
              >
                <LocalOfferIcon
                  sx={{
                    position: "relative",
                    top: "3px",
                    color: "#ffffff",
                    marginRight: ".25rem",
                    fontSize: "16px",
                  }}
                />
                <Typography
                  sx={{
                    color: "#ffffff",
                  }}
                  variant="body1"
                >
                  {data?.course_promotion_name}

                  {/* {data?.course_promotion_name} (%{data?.course_promotion_discount_amount} Discount) */}
                </Typography>
              </Box>
            ) : null}

            <Button
              href={`/residences/${data?.campus_id}`}
              sx={{
                // position: { xs: "absolute", xl: "relative" },
                // bottom: { xs: "108px", xl: "0" },
                background: theme.palette.primary.light,
                marginTop: { xs: "1rem", xl: "1rem" },
                textTransform: 'capitalize'
              }}
              variant="contained"
            >
              {t("seeResidence")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
